import { API_BASE_URL, LOGOUT_URL } from '@synergy/config';

/**
 * Where the avatar menu's last entry leads.
 *
 * Someone who reached this session through switch-user must not be signed out —
 * that would end the session of the person who did the impersonating. They are
 * handed back to their own account instead, which is why this is not a constant.
 */
export const paloSignOutHref = (isImpersonator: boolean): string =>
    isImpersonator
        ? `${API_BASE_URL}/switch-user?redirect=${encodeURI(window.location.href)}&_switch_user=_exit`
        : LOGOUT_URL;
